<ng-container *ngIf="agent as currentAgent">
  <button *ngIf="isCompact" type="button" class="agent-card agent-card--compact" (click)="open()">
    <span class="agent-card__mark" aria-hidden="true">{{ mark }}</span>
    <span class="agent-card__compact-name">{{ currentAgent.name }}</span>
  </button>

  <article *ngIf="!isCompact" class="agent-card" tabindex="0" role="button" (click)="open()" (keydown.enter)="open()" (keydown.space)="open()">
    <div class="agent-card__header">
      <div class="agent-card__heading">
        <span class="agent-card__name">{{ currentAgent.name }}</span>
        <span class="agent-card__description">{{ currentAgent.description }}</span>
      </div>
      <span class="agent-card__tag" [ngClass]="'agent-card__tag--' + availabilityTone">{{ currentAgent.roadmapLabel }}</span>
    </div>

    <div class="agent-card__tags">
      <span class="agent-card__tag" [ngClass]="'agent-card__tag--' + autonomyMeta?.tone">{{ autonomyMeta?.label }}</span>
      <span class="agent-card__tag agent-card__tag--grey">
        <svg-icon [src]="reversibilityMeta?.icon || ''" aria-hidden="true"></svg-icon>
        {{ reversibilityMeta?.label }}
      </span>
      <span class="agent-card__tag" *ngFor="let activation of activationMetas; trackBy: trackByLabel" [ngClass]="'agent-card__tag--' + activation.tone">
        <svg-icon [src]="activation.icon" aria-hidden="true"></svg-icon>
        {{ activation.label }}
      </span>
    </div>

    <div class="agent-card__sessions" *ngIf="hasSessions">
      <div class="agent-card__sessions-header">
        <span class="agent-card__label">Active sessions</span>
        <span class="agent-card__session-count">{{ sessionCountLabel }}</span>
      </div>
      <button type="button" class="agent-card__session" *ngFor="let session of currentAgent.activeSessions; trackBy: trackById" (click)="openSession(session, $event)">
        <span class="agent-card__session-dot" [ngClass]="'agent-card__session-dot--' + session.status" aria-hidden="true"></span>
        <span class="agent-card__session-scenario">{{ session.scenario }}</span>
        <span class="agent-card__session-status">{{ session.statusLabel }}</span>
      </button>
    </div>

    <div class="agent-card__footer">
      <span class="agent-card__meta">
        <svg-icon src="assets/icons/clock.svg" aria-hidden="true"></svg-icon>
        {{ currentAgent.runtime }}
      </span>
      <span class="agent-card__meta agent-card__meta--accent" *ngIf="hasKpis">
        <svg-icon src="assets/icons/stage-demand.svg" aria-hidden="true"></svg-icon>
        {{ kpiSummary }}
      </span>
      <span class="agent-card__spacer"></span>
      <span class="agent-card__cta">
        {{ callToActionLabel }}
        <svg-icon src="assets/icons/arrow-right.svg" aria-hidden="true"></svg-icon>
      </span>
    </div>
  </article>
</ng-container>
